<template>
    <CodiceFeanorView tool-module="modular" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
